
import Vue from 'vue'

export default Vue.extend({
  name: 'UiPopupMenu',
  props: {
    items: {
      type: [Array<any>, Object],
      required: true,
      default: () => {}
    },
    itemKey: {
      type: String,
      required: false,
      default: null
    },
    itemValueKey: {
      type: String,
      required: false,
      default: null
    },
    itemLabelKey: {
      type: String,
      required: false,
      default: null
    },
    selectedItem: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  methods: {
    select (value: string | number) {
      this.$emit('selected', value)
    },
    computedItemValue (item: string | any, key: string | number) {
      return this.itemValueKey === '_key' ? key : item?.[this.itemValueKey] ?? item
    }
  }
})
